/**
 * ポーリング待機: 通常はintervalミリ秒待つが、タブ復帰・スリープ復帰時は即座に解決する。
 * visibilitychange イベントを利用して、ユーザーがタブに戻った瞬間にポーリングを実行する。
 *
 * signal を渡すと abort 時にも即座に解決する (reject はしないので、呼び出し側は
 * 待機明けに signal.aborted を確認して中断処理を行うこと)。
 */
export function waitForNextPoll(interval: number, signal?: AbortSignal): Promise<void> {
  return new Promise(resolve => {
    let resolved = false;
    const done = () => {
      if (resolved) return;
      resolved = true;
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
      signal?.removeEventListener('abort', done);
      resolve();
    };
    const timer = setTimeout(done, interval);
    const onVisible = () => {
      if (document.visibilityState === 'visible') done();
    };
    document.addEventListener('visibilitychange', onVisible);
    if (signal?.aborted) {
      done();
      return;
    }
    signal?.addEventListener('abort', done);
  });
}
